module.exports = __webpack_public_path__ + "img/icon-kiosk-02.svg";